<template>
    <v-card class="elavation-1" style="border-radius:4px;"> 
        <v-toolbar flat height="45px">
            <span class="font-weight-bold ">Confirm Delete</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="text-xs-center">
            <p v-html="deleteMessage" class="msg-text"></p>
            <p>Note: you will not be able to undo this operation.</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn title="Delete" class="red" dark @click="okDelete" :loading="loading">Delete</v-btn>
            <v-btn title="Cancel" @click="closeDialog">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>

export default {
    data () {
        return {
            loading: false,
            deleteMessage: null,
        }
    },
    methods: {
        setMessage(message) {
            this.deleteMessage = message
        },
        okDelete() {
            this.loading = true
            this.$emit('okDelete', null)
            this.loading = false
        },
        closeDialog() {
            this.$emit('update:dialogDelete', false)
        },
    },
    computed: {},
    created() {}
}
</script>
<style scoped>
.msg-text {
    margin-top:10px;
}
</style>